import { forwardRef } from 'react'
import { TestimonialCard } from '@educator/components/TestimonialCard'
import type { TestimonialItem } from '@educator/components/TestimonialCard'
import type { EducatorTrackingLocation } from '@educator/tracking/educatorTracking'
import {
  PeekCarousel,
  type PeekCarouselHandle,
} from '@mc/educator-design-system'

export type TestimonialsCarouselHandle = PeekCarouselHandle

interface TestimonialsCarouselProps {
  items: TestimonialItem[]
  fromLinkedInLabel: string
  sectionLabel: string
  /** Target for `aria-controls` when the nav arrows render outside the track. */
  id?: string
  location: EducatorTrackingLocation
}

export const TestimonialsCarousel = forwardRef<
  TestimonialsCarouselHandle,
  TestimonialsCarouselProps
>(({ items, fromLinkedInLabel, sectionLabel, id, location }, ref) => (
  // PeekCarousel owns the labelled region but takes no id, so the
  // aria-controls target is this wrapper.
  <div id={id}>
    <PeekCarousel
      ref={ref}
      loop
      ariaLabel={sectionLabel}
      // --peek-card-w (288/640, matches TestimonialCard) centers the active card.
      className='gap-2 py-1 [--peek-card-w:288px] md:gap-4 md:[--peek-card-w:640px]'
      slideClassName='transition-opacity duration-300 ease-in-out data-[active=false]:opacity-40 md:data-[active=false]:opacity-20'
    >
      {items.map((item) => (
        <TestimonialCard
          key={item.id}
          {...item}
          fromLinkedInLabel={fromLinkedInLabel}
          location={location}
        />
      ))}
    </PeekCarousel>
  </div>
))

TestimonialsCarousel.displayName = 'TestimonialsCarousel'
